
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/terms/abuse",
      function () {
        return require("private-next-pages/terms/abuse/index.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/terms/abuse"])
      });
    }
  